import React from 'react';

function Command(props) {
  return (
    <button className="commandButton" onClick={() => props.onClick()} style={{color:"darkblue"}}>
      {props.value}
    </button>
  );
}

function CalculationCommand(props) {
  return (
    <button className="undoButton" onClick={() => props.onClick()}>
      {props.value}
    </button>
  );
}

function NormalButton(props) {
  return (
    <button className="calculationButton" onClick={() => props.onClick()} >
      {props.value}
    </button>
  );
}
function NoClickButton(props) {
  return (
    <button className="calculationButton" >
      {props.value}
    </button>
  );
}


function DisabledButton(props) {
  return (
    <button className="disabledButton" >
      {props.value}
    </button>
  );
}

function Solution(props) {
  return (
    <p className="solution">
      {props.value}
    </p>
  );
}

function Success() {
  return (
    <p className="solution success">
      Success, difference = 0
    </p>
  );
}

function SummaryLines(props) {
  const lines = props.summaryLines;
  const listItems = lines.map((line, index) =>
  <p className="solution" key={index.toString()}>{line}</p>
  );
  return (
      <div>{listItems}</div>
  );
}
      
export class Board extends React.Component {

  constructor(props) {
    super(props);
  }

  renderSymbol(symbolExpr) {
    if (symbolExpr.isAvailable) {
      return (
        <NormalButton
          value={symbolExpr.itemValue}
          onClick={() => this.props.onSymbolClick(symbolExpr.itemIndex)} />
      );
    }

    if (symbolExpr.isUsed) {
      return (
        <DisabledButton
        value={symbolExpr.itemValue} />
      );
    }

    return (
      <NoClickButton
        value={symbolExpr.itemValue} />
    );
  }

  renderBlank(value) {
    return (
      <DisabledButton
        value={value} />
    );
}

  renderCommand(symbol, command) {
    return (
      <Command
        value={symbol}
        onClick={() => this.props.onCommandClick(command)} />
    );
  }

  renderCalulationCommand(symbol, command) {
    return (
      <CalculationCommand
        value={symbol}
        onClick={() => this.props.onCommandClick(command)} />
    );
  }

  renderSolution(text1) {
    return (
      <Solution
        value={text1} />
    );
  }


  renderSummaryLines(lines) {
    return (
      <SummaryLines
      summaryLines={lines} />
    );
  }

  renderSummary(text1) {
    return (
      <Solution
        value={text1} />
    );
  }

  renderResult(difference) {

    if (difference === 0) {
      return (
        <Success />
      );
  
    }
    return (
      <Solution
        value={'Difference = ' + difference} />
    );
  }

  render() {

    let result = 
      <div className="container">
        <div className="row">
          <div className="col-12 boardContainer">
            <div className="row">
              <div className="col-3 controlContainer">{this.renderCommand('New', 'New')}</div>
              <div className="col-3 controlContainer">{this.renderCommand('Nums', 'Numbers')}</div>
              <div className="col-3 controlContainer">{this.renderCommand('Solve', 'Solve')}</div>
              <div className="col-3 controlContainer">{this.renderCommand('Option', 'Options')}</div>
            </div>
            <div className="row">
              <div className="col-3 controlContainer">{this.renderSymbol(this.props.expressionItems[0])}</div>
              <div className="col-3 controlContainer">{this.renderSymbol(this.props.expressionItems[1])}</div>
              <div className="col-3 controlContainer">{this.renderSymbol(this.props.expressionItems[6])}</div>
              <div className="col-3 controlContainer">{this.renderSymbol(this.props.expressionItems[7])}</div>
            </div>
            <div className="row">
              <div className="col-3 controlContainer">{this.renderSymbol(this.props.expressionItems[2])}</div>
              <div className="col-3 controlContainer">{this.renderSymbol(this.props.expressionItems[3])}</div>
              <div className="col-3 controlContainer">{this.renderSymbol(this.props.expressionItems[8])}</div>
             <div className="col-3 controlContainer">{this.renderSymbol(this.props.expressionItems[9])}</div>
            </div>
            <div className="row">
            <div className="col-3 controlContainer">{this.renderSymbol(this.props.expressionItems[4])}</div>
              <div className="col-3 controlContainer">{this.renderSymbol(this.props.expressionItems[5])}</div>
              <div className="col-3 controlContainer">{this.renderSymbol(this.props.expressionItems[10])}</div>
             <div className="col-3 controlContainer">{this.renderSymbol(this.props.expressionItems[11])}</div>
            </div>
              <div className="row">
              <div className="col-3 controlContainer">{this.renderCalulationCommand('Clear', 'Clear')}</div>
              <div className="col-3 controlContainer">{this.renderCalulationCommand('Undo', 'Undo')}</div>
              <div className="col-3 controlContainer">{this.renderSymbol(this.props.expressionItems[12])}</div>
              <div className="col-3 controlContainer">{this.renderSymbol(this.props.expressionItems[13])}</div>
            </div>
            <div className="row">
              <div className="col-12">
                {this.renderSolution(this.props.solution)}
              </div>
            </div>
            <div className="row">
              <hr />
            </div>
            <div className="row">
              <div className="col-12">
                {this.renderSummaryLines(this.props.calculatedLines)}
              </div>
            </div>
            <div className="row">
              <hr />
            </div>
            <div className="row">
              <div className="col-12">
                {this.renderSummary('Target = ' + this.props.targetNumber)}
                {this.renderSummary('Calculation = ' + this.props.calculatedTotal)}
              </div>
            </div>
            <div className="row">
              <hr />
            </div>
            <div className="row">
              <div className="col-12">
                {this.renderResult((this.props.targetNumber - this.props.calculatedTotal))}
              </div>
            </div>
            <div className="row">
              <hr />
            </div>
          </div>
        </div>
        <div className="footer">
          by MickBraz
        </div>
      </div>;

return result;
  }
}
